export const getElementHeight = (element) =>
	(element && element.getBoundingClientRect().height) || 0;

export const isTranslatedOutOfView = (element) =>
	!!element && element.getBoundingClientRect().bottom <= 0;

// Check if an element is visible in the viewport. Considers: position, dimensions, display, and visibility styles
export const isElementVisible = (element) => {
	if (!element) return false;
	const rect = element.getBoundingClientRect();
	return (
		rect.top + rect.height >= 0 &&
		element.offsetWidth > 0 &&
		element.offsetHeight > 0 &&
		getComputedStyle(element).display !== 'none' &&
		getComputedStyle(element).visibility !== 'hidden'
	);
};

// Get the maximum visible height from a container and its children
export const getMaxVisibleHeight = (container) => {
	if (!container || !isElementVisible(container)) return 0;
	const visibleElements = Array.from(container.children).filter((el) =>
		isElementVisible(el)
	);

	if (
		visibleElements.length === 1 &&
		visibleElements[0].classList.contains('minimal') &&
		visibleElements[0].offsetHeight > 0
	) {
		return visibleElements[0].offsetHeight;
	}
	const heights = [
		container.offsetHeight,
		...visibleElements.map((el) => el.offsetHeight)
	];
	return Math.max(0, ...heights);
};

// Get all required DOM elements for sticky toolbar functionality
export const getDOMElements = () => ({
	header: document.querySelector('.page-header'),
	stickyHeaderNav: document.querySelector('.page-header, .navbar-default'),
	vehicleCtas: document.querySelector('[data-widget-id="vehicle-ctas1"]'),
	vehicleToolbar: document.querySelector(
		'div[data-name="vdp-sticky-vehicle-toolbar-wrapper-1"]'
	),
	alert: document.querySelector('[data-widget-id="template-alert1"]')
});

// Validate that all required DOM elements exist
export const validateDOMElements = (dom) =>
	!!(
		dom.vehicleToolbar &&
		dom.vehicleToolbar.querySelector('.ws-vehicle-toolbar') &&
		dom.vehicleCtas &&
		dom.header
	);

// Get header configuration based on DOM and DDC properties
export const getHeaderConfig = ({ dom, DDC, displayOnBottom = false }) => ({
	isNotSticky:
		dom.stickyHeaderNav?.classList.contains('notSticky') ||
		DDC.siteProperties?.templateHeaderDisableSticky,
	noShrink: dom.stickyHeaderNav?.classList.contains('noShrink'),
	mobileNavbar: DDC.client.isMobile
		? dom.header.querySelector(
				'[data-widget-id="template-navbar1"] .navbar'
		  )
		: null,
	isEntireMobileHeaderFixed:
		DDC.client.isMobile &&
		!!dom.header.querySelector('.minimal, .audi-header-alt'),
	displayOnBottom: DDC.client.isMobile && displayOnBottom
});
